import { Outlet } from 'react-router'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'
import { lazy } from '~/router/lazy'
import { useChartParams } from '~/router/params'
import { RouteObject } from '~/router/types'
import { ChartDetailsProvider } from './ChartDetailsProvider'

export const chartRoute: RouteObject = {
  path: 'chart/:chart_id',
  Component: ChartLayout,
  handle: { objectType: BreadcrumbObjectType.CHART },
  children: [
    {
      index: true,
      lazy: lazy(() => import('./ChartController')),
      handle: {
        pageType: 'chart',
        showActivityFeed: true,
        showBackLink: true,
      },
    },
    {
      path: 'settings',
      lazy: lazy(() => import('./ChartSettingsController')),
      handle: {
        pageType: 'chartSettings',
        crumb: 'title_bar.chart_settings',
        showLeftNav: false,
        showBackLink: true,
      },
    },
  ],
}

/** Wraps chart routes in ChartDetailsProvider so detail + settings share chart data. */
function ChartLayout() {
  const { chart_id } = useChartParams()
  return (
    <ChartDetailsProvider chartId={chart_id}>
      <Outlet />
    </ChartDetailsProvider>
  )
}
